module.exports = __webpack_public_path__ + "img/slide3.404fbd30.webp";